/**
 * Form/action shape for the Accounto connect step (REV-21119 D1).
 *
 * The customer supplies two fields in the connect modal; the service maps them into the generic
 * create envelope (`POST /api/integrations/accounto` with `{ displayName, vendorInput: { apiKey } }`).
 * The BE reads `tenant_id` and `exp` from the key (a JWT), checks it against Accounto (tenant, key
 * kind, a one-row account read) and persists the connection atomically. There is no server URL: the
 * Accounto API address is BE config (D2).
 *
 * Security note: `apiKey` carries full read/write rights on the tenant(s) (Accounto has no scopes). It
 * flows through the NgRx action stream (blanked for the DevTools by `redactConnectSecretsForDevtools`)
 * and the HTTP call; the BE encrypts it at rest via a per-connection DEK and never returns it. Do NOT
 * log this object or echo it back to the user.
 */
export interface IAccountoConnectBody {
    /** UI label for the connection, surfaced in the manage modal list. */
    displayName: string;
    /** Accounto API key (JWT). Sensitive. */
    apiKey: string;
}
